import { Api } from "@relode/core";
import { responses as coreResponses } from "@relode/core/backend";

import { JobTotalCountResponse, JobStatisticsResponse } from ".";

export const managerDashboardService = {
    getJobCountsForClientManager: async (showAllJobs: boolean) => {
        const url = "/dashboard/hiring-team-manager/jobs/total";

        const result = await Api.url(url)
            .retries(3)
            .throwOnAbort()
            .useSignal()
            .track({
                name: "managerDashboardService.getOpenJobsForClientManager",
            })
            .get<JobTotalCountResponse>({ isAllJobs: showAllJobs });

        return result;
    },

    getPausedJobsForClientManager: async (showAllJobs: boolean) => {
        const url = "/dashboard/hiring-team-manager/jobs/paused/total";

        const result = await Api.url(url)
            .retries(3)
            .throwOnAbort()
            .useSignal()
            .track({
                name: "managerDashboardService.getPausedJobsForClientManager",
            })
            .get<coreResponses.TotalCountResponse>({ isAllJobs: showAllJobs });

        return result;
    },

    getClosedJobsForClientManager: async (showAllJobs: boolean) => {
        const url = "/dashboard/hiring-team-manager/jobs/closed/total";

        const result = await Api.url(url)
            .retries(3)
            .throwOnAbort()
            .useSignal()
            .track({
                name: "managerDashboardService.getClosedJobsForClientManager",
            })
            .get<coreResponses.TotalCountResponse>({ isAllJobs: showAllJobs });

        return result;
    },

    getCandidatesInSubmittedStatus: async (showAllJobs: boolean) => {
        const url = "/dashboard/hiring-team-manager/candidates/submitted/total";

        const result = await Api.url(url)
            .retries(3)
            .throwOnAbort()
            .useSignal()
            .track({
                name: "managerDashboardService.getCandidatesInSubmittedStatus",
            })
            .get<coreResponses.TotalCountResponse>({ isAllJobs: showAllJobs });

        return result;
    },

    getCandidatesInInterviewingPastStatus: async (showAllJobs: boolean) => {
        const url =
            "/dashboard/hiring-team-manager/candidates/interviewing/past";

        const result = await Api.url(url)
            .retries(3)
            .throwOnAbort()
            .useSignal()
            .track({
                name:
                    "managerDashboardService.getCandidatesInInterviewingPastStatus",
            })
            .get<coreResponses.TotalCountResponse>({ isAllJobs: showAllJobs });

        return result;
    },

    getCandidatesInInterviewingPastAwaitingFeedbackStatus: async (
        showAllJobs: boolean
    ) => {
        const url =
            "/dashboard/hiring-team-manager/candidates/interviewing/past/awaiting-feedback";

        const result = await Api.url(url)
            .retries(3)
            .throwOnAbort()
            .useSignal()
            .track({
                name:
                    "managerDashboardService.getCandidatesInInterviewingPastAwaitingFeedbackStatus",
            })
            .get<coreResponses.TotalCountResponse>({ isAllJobs: showAllJobs });

        return result;
    },

    getCandidatesInInterviewingUpcomingdStatus: async (
        showAllJobs: boolean
    ) => {
        const url =
            "/dashboard/hiring-team-manager/candidates/interviewing/upcoming";

        const result = await Api.url(url)
            .retries(3)
            .throwOnAbort()
            .useSignal()
            .track({
                name:
                    "managerDashboardService.getCandidatesInInterviewingUpcomingStatus",
            })
            .get<coreResponses.TotalCountResponse>({ isAllJobs: showAllJobs });

        return result;
    },

    getCandidatesInOfferedStatus: async (showAllJobs: boolean) => {
        const url = "/dashboard/hiring-team-manager/candidates/offered/total";

        const result = await Api.url(url)
            .retries(3)
            .throwOnAbort()
            .useSignal()
            .track({
                name: "managerDashboardService.getCandidatesInOfferedStatus",
            })
            .get<coreResponses.TotalCountResponse>({ isAllJobs: showAllJobs });

        return result;
    },

    getCandidatesInHiredConfirmedStatus: async (showAllJobs: boolean) => {
        const url = "/dashboard/hiring-team-manager/candidates/hired/confirmed";

        const result = await Api.url(url)
            .retries(3)
            .throwOnAbort()
            .useSignal()
            .track({
                name:
                    "managerDashboardService.getCandidatesInHiredConfirmedStatus",
            })
            .get<coreResponses.TotalCountResponse>({ isAllJobs: showAllJobs });

        return result;
    },

    getCandidatesInHiredUnconfirmedStatus: async (showAllJobs: boolean) => {
        const url =
            "/dashboard/hiring-team-manager/candidates/hired/unconfirmed";

        const result = await Api.url(url)
            .retries(3)
            .throwOnAbort()
            .useSignal()
            .track({
                name:
                    "managerDashboardService.getCandidatesInHiredUnconfirmedStatus",
            })
            .get<coreResponses.TotalCountResponse>({ isAllJobs: showAllJobs });

        return result;
    },

    getHiringTeamManagerStatistics: async (showAllJobs: boolean) => {
        const url = "/dashboard/hiring-team-manager/stats";

        const result = await Api.url(url)
            .retries(3)
            .throwOnAbort()
            .useSignal()
            .track({ name: "" })
            .get<JobStatisticsResponse>({
                isAllJobs: showAllJobs,
            });

        return result;
    },
};
